import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, finalize, tap } from 'rxjs/operators';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment.js';
import Swal from 'sweetalert2';
import { Users } from 'src/app/models/users.model';
import { PricingService } from 'src/app/services/pricing.service';

@Component({
    selector: 'app-user-used-pakage',
    templateUrl: './user-used-pakage.component.html',
    styleUrls: ['./user-used-pakage.component.scss'],
    standalone: false
})
export class UserUsedPakageComponent implements OnInit {

  constructor(
    public modal: NgbActiveModal,

    public service: PricingService, public translateService: TranslateService,
  ) {
  }
  edit(id: number) {

  }
  model: any;
  ngOnInit(): void {
    this.service.getUserCredit$().subscribe(x => {
      this.model = x;
    })
  }
}